import { Clock, MapPin, Users, Utensils, Sparkles } from "lucide-react";
import Reveal from "@/components/Reveal";

const FACTS = [
  {
    icon: Clock,
    label: "When",
    value: "12-ish",
    sub: "4 – 5 hours, unhurried",
  },
  {
    icon: MapPin,
    label: "Where",
    value: "Andrea's Home",
    sub: "Uliului street, Cluj-Napoca",
  },
  {
    icon: Users,
    label: "Group",
    value: "2 – 8 guests",
    sub: "Private & intimate",
  },
  {
    icon: Utensils,
    label: "Menu",
    value: "3 + 3 dishes",
    sub: "Traditional & modern",
  },
  {
    icon: Sparkles,
    label: "Included",
    value: "Pălincă, ice cream",
    sub: "Lemonade, sparkling water",
  },
];

/** A scannable "what is this, in 10 seconds" card. ADHD-friendly:
 *  - icon + label + bold value + small clarifier
 *  - works as a grid on tablet/desktop, a vertical list on mobile
 *  - placed right after the hero so visitors get the gist before the prose */
export default function QuickFacts() {
  return (
    <section
      className="relative px-6 sm:px-10 md:px-16 lg:px-24 py-16 sm:py-20 border-b border-[color:var(--rule)]"
      data-testid="quick-facts-section"
      aria-label="Quick facts at a glance"
    >
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <p className="eyebrow">
            <span className="text-[color:var(--gold)]">·</span> The lunch at a glance
          </p>
        </Reveal>

        <ul
          className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-8"
          data-testid="quick-facts-list"
        >
          {FACTS.map((f, i) => {
            const Icon = f.icon;
            return (
              <Reveal key={f.label} delay={i * 0.04}>
                <li
                  className="flex items-start gap-4 border-t border-[color:var(--rule)] pt-5"
                  data-testid={`quick-fact-${f.label.toLowerCase()}`}
                >
                  <Icon
                    size={22}
                    strokeWidth={1.5}
                    className="text-[color:var(--gold)] mt-1 flex-none"
                    aria-hidden="true"
                  />
                  <div>
                    <p className="font-hand text-lg text-[color:var(--moss)] leading-none">
                      {f.label}
                    </p>
                    <p className="font-display text-2xl sm:text-3xl text-[color:var(--ink)] leading-tight mt-2">
                      {f.value}
                    </p>
                    <p className="font-body text-sm text-[color:var(--ink-2)] mt-1.5 leading-snug">
                      {f.sub}
                    </p>
                  </div>
                </li>
              </Reveal>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
